import React, { useRef } from 'react';
var VeltNotificationsToolUnreadCount = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-tool-unread-count", { ref: ref }, children));
};
export default VeltNotificationsToolUnreadCount;
